import { Box } from "components";
import { format } from "date-fns";
import { compose, withHooks } from "enhancers";
import {
  DatePicker as FormikMuiDatePicker,
  DateTimePicker as FormikMuiDateTimePicker,
} from "formik-material-ui-pickers";

import { ReactComponent as DatePickerIcon } from "assets/icon/datepicker_icon.svg";
import { replaceNameSpace } from "utils/helper";
import T from "./T";

const DatePicker = (props: any) => {
  const { time, ...restProps } = props;
  const PickerComponent = time ? FormikMuiDateTimePicker : FormikMuiDatePicker;

  return (
    <Box position="relative" width="100%">
      <PickerComponent {...restProps} />
      <Box
        position="absolute"
        top={16}
        right={12}
        style={{ pointerEvents: "none" }}
      >
        <DatePickerIcon />
      </Box>
    </Box>
  );
};

const enhancer = compose(
  withHooks((props: any, hooks: any) => {
    const { useMemo, useCallback } = hooks;

    const defaultFormat = props.time ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy";
    const defaultPlaceholder = props.time ? "00/00/0000 00:00" : "00/00/0000";

    const onChange = useCallback(
      (date: any) => {
        props.form.setFieldValue(props.field.name, date);
        props.form.setFieldTouched(props.field.name, true, false);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.form, props.field.name]
    );

    const FormHelperTextProps = useMemo(
      () => ({
        component: (props: any) => (
          <T variant="Helper/12" className={props.className}>
            {replaceNameSpace("yup.error", props.children)}
          </T>
        ),
      }),
      []
    );

    return {
      format: defaultFormat,
      placeholder: defaultPlaceholder,
      ...props,
      onChange,
      labelFunc: (date: Date, invalidLabel: string) =>
        props.field.value ? format(date, props.format || defaultFormat) : "",
      FormHelperTextProps,
    };
  })
);

export default enhancer(DatePicker);
